/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Admin_Subject_RequiredInputs */

const en_mail_admin_subject_required = /** @type {(inputs: Mail_Admin_Subject_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a subject.`)
};

const de_mail_admin_subject_required = /** @type {(inputs: Mail_Admin_Subject_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte tragen Sie einen Betreff ein.`)
};

/**
* | output |
* | --- |
* | "Please enter a subject." |
*
* @param {Mail_Admin_Subject_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_admin_subject_required = /** @type {((inputs?: Mail_Admin_Subject_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Admin_Subject_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_admin_subject_required(inputs)
	return en_mail_admin_subject_required(inputs)
});